import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[BusinessType SetFilter] Action',
  ResetFilter: '[BusinessType ResetFilter] Action',
}

const initialBusinessTypeState: IBusinessTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IBusinessTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-BusinessType', whitelist: ['filter']},
  (
    state: IBusinessTypeState = initialBusinessTypeState,
    action: ActionWithPayload<IBusinessTypeState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialBusinessTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
